export default __webpack_public_path__ + "static/media/banner.b0c76976.png";